<template>
  <v-navigation-drawer
    app
    right
    fixed
    v-model="navigation"
    width="100%"
    height="100%"
    touchless
    class="app-navigation pa-3 pb-0"
    disable-resize-watcher
  >
    <template v-slot:append>
      <AppContacts style="font-size:10px;background:#e5e5e5;height:80px" class="px-3 mx-n3" />
    </template>
    <div class="d-flex">
      <span class="navigation-title primary--text" v-html="$t('navigationTitle')"></span>
      <div class="ml-auto">
        <v-btn icon @click="switchNavigation(false)">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
    <v-divider class="my-3" />
    <v-list>
      <template v-for="(navigationItem,navigationIndex) in navigationItems">
        <v-list-group
          :key="navigationIndex"
          v-if="navigationItem.children&&navigationItem.children.length"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{$t(navigationItem.text)}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <SubNavigationList :to="navigationItem.to" :items="navigationItem.children" />
        </v-list-group>
        <v-list-item
          v-else
          :to="navigationItem.to"
          :href="navigationItem.href"
          :target="navigationItem.to?'_self':'_blank'"
          :key="navigationIndex"
        >{{$t(navigationItem.text)}}</v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import baseModule from "@/store/base.module";
import AppContacts from "@/components/ui/AppContacts.vue";
import SubNavigationList from "@/components/ui/SubNavigationList.vue";

@Component({
  components: { AppContacts, SubNavigationList },
  methods: { switchNavigation: baseModule.switchNavigation },
})
export default class extends Vue {
  get navigation() {
    return baseModule.navigation;
  }
  set navigation(value: boolean) {
    baseModule.switchNavigation(value);
  }

  get navigationItems() {
    return baseModule.navigationItems;
  }
}
</script>
<style lang="scss" >
.app-navigation {
  .v-list-item__title,
  .v-list-item {
    font-size: 12px;
    line-height: 14px;
  }
}
.navigation-title {
  font-size: 14px;
  line-height: 16px;
}
</style>